export default __webpack_public_path__ + "static/media/HustleFund.af2eeee1.svg";